// src/pages/News.js

import React from 'react';
import '../styles/News.css';

function News() {
  const newsItems = [
    {
      title: "🌍 CarbonBank launches new eco-initiative for 2025",
      content: "CarbonBank™ is launching a new carbon capture and renewable energy integration model, aiming to accelerate net-zero transitions for global industries.",
    //   link: "https://carbonbank.com/initiative-2025"
    },
    {
      title: "🎤 Sustainability meets innovation at Global Climate Summit",
      content: "Our team presented breakthrough CarbonBank technology, showing how low-cost direct air capture can reshape the green energy landscape."
    },
    {
      title: "🔬 Research partnership with top environmental institute",
      content: "CarbonBank™ has partnered with leading researchers to explore scalable methods for carbon storage.",
    //   link: "https://carbonbank.com/research-partnership"
    },
  ];

  return (
    <div className="news-page">
      <div className="news-feed">
        <h1 className="news-header">News & Updates</h1>
        {newsItems.map((item, index) => (
          <div key={index} className="news-card">
            <div className="news-title">
              {item.link ? (
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  {item.title}
                </a>
              ) : (
                item.title
              )}
            </div>
            <div className="news-body">{item.content}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default News;
